module.exports = __webpack_public_path__ + "img/jorify_cg_white.90d8ebc4.svg";